export default [
    {
        path: 'fila',
        component: () => import(
            /* webpackChunkName: 'regulacao-fila' */
            '@/views/regulacao/fila/Index'
        ),
        redirect: 'fila/index',
        children: [
            {
                name: 'regulacao-fila-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'regulacao-fila' */
                    '@/views/regulacao/fila/List.vue'
                ),
            },
        ],
    },
]